import { render, staticRenderFns } from "./ReporteSaldoVendedor.vue?vue&type=template&id=70cf9e78&scoped=true"
import script from "./ReporteSaldoVendedor.vue?vue&type=script&lang=js"
export * from "./ReporteSaldoVendedor.vue?vue&type=script&lang=js"
import style0 from "./ReporteSaldoVendedor.vue?vue&type=style&index=0&id=70cf9e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf9e78",
  null
  
)

export default component.exports